<template>
  <div class="statistics-box">
    <div class="echart-centent">
      <pi-echarts-line :type="type" :chartData="chartDataObj"></pi-echarts-line>
    </div>
    <template v-for="(item, index) in blockDataList">
      <pi-statistics-block :blockData="item" :key="index"></pi-statistics-block>
    </template>
  </div>
</template>
<script>
import statisticsData from "../../my-statistics-data.js";
import statisticsChartData from "../../my-statistics-chart-data.js";
import echartsLine from '../echarts-line/echarts-line.vue'
import statisticsBlock from '../statistics-block/statistics-block.vue'
export default {
  name: "pi-statistics-centent",
  components: {
    [echartsLine.name]: echartsLine,
    [statisticsBlock.name]: statisticsBlock,
  },
  data() {
    return {
      blockDataList: [],
      chartDataObj: {},
    };
  },
  props: {
    type: {
      type: String,
      default: "", // memberDl: 按电量
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.blockDataList = await statisticsData[this.type]();
      this.chartDataObj = await statisticsChartData[this.type]();
    },
  },
};
</script>

<style lang="less" scoped>
.statistics-box{
  padding: 0.20rem;
}
.echart-centent{
  height: 3.76rem;
  background: #fff;
  border-radius: 0.16rem;
  box-shadow: 0px 0px 0.10rem 0px #EFEFF4;
}
</style>
